import {
    getToken,
    setToken,
    getUserInfo,
    setUserInfo,
    removeUserInfo,
    removeToken
} from '@/utils/auth'
import {
    fnCookie
} from '@/utils/localStorage'
import cryptoJs from 'crypto-js'
import axios from 'axios';
import {
    Message
} from 'element-ui';
import sha1 from 'js-sha1';
import * as imageConversion from 'image-conversion';
import request from '@/utils/request';
const APP = {
    isTest: 0, // 是否为测试环境;1:测试环境;0:正式环境
    YES: 1,
    NO: 0,
    // 分页相关
    PAGE: {
        LIMIT: 10, // 每页默认显示条数
        SKIP_PAGE: 1, // 跳过条数
        SIZE_OPTION: [10, 20, 50, 100, 500, 1000], // 每页显示条数选项
        PAGE: 1 // 初始页码
    },
    // 考勤上传地址
    ATTENDANCE_SITE: {
        liangjiang: 'lj', // 上传至两江新区
        chongqing: 'cq' // 上传至重庆市建委
    },
    // 接口请求地址
    HOST: {
        TEST: { // 测试地址
            BASE_URL: 'http://test-bt.zgjkj.com:18313',
            ADMIN_TASK_1_URL: 'http://test-bt.zgjkj.com:18309', // TASK1接口地址
            ADMIN_URL_MONITOR: 'http://zgj-api.zgjkj.com/monitor/', // 监控调用地址
            FILE_UPLOAD: 'https://zgj-api.zgjkj.com/file/upload', // 文件上传地址
            TASK_DELIVER: 'http://test-bt.zgjkj.com:1831', // 设备任务投递
            TOPROJECT_URL: 'http://47.112.25.30:18311', // 跳转老项目端地址
            TARGET_URL: 'http://localhost:8081/#/attendance/UnitIndex', // 跳转至项目端接收地址 老项目端
            ENTER_URL: 'http://localhost:8080/#/login', // 跳转至企业端接收地址 企业端
            EQPT_URL: 'https://eqpt.crane.zgjkj.com', // 塔机/升降机 - 灿远
            EQPT_JZ_URL: 'https://jz.crane.zgjkj.com/', // 塔机标定 - 巨正
        },
        OFFICIAL: { // 正式地址
            BASE_URL: 'https://zgj-api.v2.zgjkj.com',
            ADMIN_TASK_1_URL: 'https://zgj-api.zgjkj.com/Task-1', // TASK1接口地址
            ADMIN_TASK_2_URL: 'https://zgj-api.zgjkj.com/Task-2', // TASK2接口地址
            ADMIN_URL_MONITOR: 'https://zgj-api.zgjkj.com/monitor/', // 监控调用地址
            FILE_UPLOAD: 'https://zgj-api.zgjkj.com/file/upload', // 文件上传地址
            TASK_DELIVER: 'https://access.zgjkj.com', // 设备任务投递
            TOPROJECT_URL: 'https://zgj-api.zgjkj.com', // 跳转老项目端地址
            TARGET_URL: 'https://zgj.zgjkj.com/#/attendance/UnitIndex', // 跳转至项目端接收地址 老项目端
            ENTER_URL: 'https://www.zgjkj.com/login', // 跳转至企业端接收地址 企业端
            EQPT_URL: 'https://eqpt.crane.zgjkj.com', // 塔机/升降机 - 灿远
            EQPT_JZ_URL: 'https://jz.crane.zgjkj.com/', // 塔机标定 - 巨正
        }
    },
    resolveApiBaseUrl() {
        if (/\.local$|^localhost$|^127\.0\.0\.1$/.test(location.hostname)) {
            return 'http://zgj.app.zgjkj.local'
        }
        return this.isTest ? this.HOST.TEST.BASE_URL : this.HOST.OFFICIAL.BASE_URL
    },
    resolveFileUploadUrl() {
        if (/\.local$|^localhost$|^127\.0\.0\.1$/.test(location.hostname)) {
            // 文件上传在 api 服务，不在 zgj.app
            return 'http://api.zgjkj.local/file/upload'
        }
        return this.isTest ? this.HOST.TEST.FILE_UPLOAD : this.HOST.OFFICIAL.FILE_UPLOAD
    },
    // http 响应状态码
    HTTP_STATUS: {
        SUCCESS: 1,
        ERROR: 2
    },
    // 打卡状态
    SIGN_TYPE: {
        invalid: 0, // 无效
        entry: 1, // 进门
        exit: 2, // 出门
        reentry: 3, // 重复进门
        reexit: 4 // 重复出门
    },
    // 判断区域id
    fnCheckRegion(_regionID) {
        let userInfo = getUserInfo()
        let region = userInfo.region.split(',')
        return region.indexOf(_regionID) != -1
    },
    // 打卡类型
    fnSignType: function(_type) {
        let _text = '';
        if (_type == APP.SIGN_TYPE.invalid) {
            _text = '无效打卡';
        } else if (_type == APP.SIGN_TYPE.entry) {
            _text = '进门';
        } else if (_type == APP.SIGN_TYPE.exit) {
            _text = '出门';
        } else if (_type == APP.SIGN_TYPE.reentry) {
            _text = '重复进门';
        } else if (_type == APP.SIGN_TYPE.reexit) {
            _text = '重复出门';
        }
        return _text;
    },
    // 获取随机数
    fnGetRandom_public: function(_min, _max) {
        return Math.floor(Math.random() * (_max - _min)) + _min
    },
    // 生成 _len 位随机数 不包含数字 0
    fnGetRandomNum: function(_len) {
        var num = '';
        for (var i = 0; i < _len; i++) {
            num += Math.floor(Math.random() * 9 + 1);
        }
        return num
    },
    // 年份格式化 20190704 -> 2019-07-04
    fnDateAddEm_public: function(_date) {
        if (!_date || _date.length !== 8) return _date
        _date = _date.substring(0, 4) + '-' + _date.substring(4, 6) + '-' + _date.substring(6)
        return _date
    },
    // 年份格式化 2019-07-04 -> 20190704
    fnDateReduceEm_public: function(_date) {
        _date = _date.substring(0, 4) + _date.substring(5, 7) + _date.substring(8)
        return _date
    },
    // 时间截取 标准时间->10:05:45
    fnDateToTime: function(_date) {
        if (!_date) return
        return new Date(_date).Format('hh:mm:ss')
    },
    // 格式化时间戳 时间戳->2019-07-25
    fnGetDateFormat: function(_date) {
        let _myDate = new Date(_date)
        let _year = _myDate.getFullYear()
        let _month = APP.fnAddZero_public(_myDate.getMonth() + 1)
        let _day = APP.fnAddZero_public(_myDate.getDate())
        return _year + '-' + _month + '-' + _day
    },
    // 当天日期 yyyy-MM-dd
    fnTodayDate: function() {
        return APP.fnGetDateFormat(new Date())
    },
    // 少于10补零
    fnAddZero_public: function(_num) {
        return _num < 10 ? '0' + _num : _num
    },
    // 数据json化
    formatJson: function(filterVal, jsonData) {
        return jsonData.map(v =>
            filterVal.map(j => {
                if (j === 'timestamp') {
                    return parseTime(v[j]);
                } else {
                    return v[j];
                }
            })
        );
    },
    // 上传区域文字转换
    fnUploadObjToText: function(_uploadObj) {
        if (!_uploadObj) return '未上传'
        _uploadObj = typeof _uploadObj === 'object' ? _uploadObj : JSON.parse(_uploadObj)
        let _arr = []
        let _site = ''
        let _obj = fnCookie('uploadRegion')

        for (let _item in _uploadObj) {
            if (_obj[_item]) {
                _site = '已上传至' + _obj[_item] + '—' + _uploadObj[_item]
                _arr.push(_site)
            }
        }
        if (!_arr.length) return '未上传'
        return _arr.join('\n')
    },
    // 获取时间
    fnGetTime: function(type) {
        let now = new Date()
        let year = now.getFullYear()
        let month = now.getMonth() + 1 //得到月份
        let date = now.getDate() //得到日期
        let hour = now.getHours() //得到小时
        let minu = now.getMinutes() //得到分钟
        let sec = now.getSeconds() //得到秒
        if (month < 10) month = '0' + month
        if (date < 10) date = '0' + date
        if (hour < 10) hour = '0' + hour
        if (minu < 10) minu = '0' + minu
        if (sec < 10) sec = '0' + sec
        let time = ''
        if (type == 'upload') {
            time = '' + year + month + date
        } else {
            time = year + '-' + month + '-' + date + ' ' + hour + ':' + minu + ':' + sec
        }
        return time
    },
    // 图片 url - base64  按大小(kb) 压缩
    fnDealPic: function(_img, _size, _cb) {
        if (!_img) {
            _cb && _cb('');
            return
        }
        imageConversion.urltoBlob(_img).then(_res => {
            imageConversion.compressAccurately(_res, _size).then(ress => {
                imageConversion.filetoDataURL(ress).then(res => {
                    let _base64 = res.split(',')[1]
                    _cb && _cb(_base64);
                });
            });
        });
    },
    /**
     * 图片压缩
     * _path: 图片路径
     * _obj: {
     *   width: 图片宽度,
     *   height: 图片高度,
     *   quality: 图片质量
     * }
     * _cb: 回调函数
     * 图片转base64格式
     * */
    fnDealImage: function(_path, _obj, _cb) {
        if (typeof _obj === 'function') {
            _cb = _obj
            _obj = {}
        }
        let _img = new Image()
        _img.crossOrigin = '*'
        // _img.src = _path + '?v=' + Math.random()
        _img.src = _path
        _img.onload = function() {
            let _that = this
            // 计算图片比例
            let _w = _that.width,
                _h = _that.height,
                _scale = _w / _h
            _w = _obj.width || _w
            _h = _obj.height || (_w / _scale)

            let _quality = 0.7 // 默认图片质量
            // 生成一个canvas
            let _canvas = document.createElement('canvas')
            let _context = _canvas.getContext('2d')
            // 创建属性节点
            let _elW = document.createAttribute('width')
            _elW.nodeValue = _w
            let _elH = document.createAttribute('height')
            _elH.nodeValue = _h
            _canvas.setAttributeNode(_elW)
            _canvas.setAttributeNode(_elH)
            _context.drawImage(_that, 0, 0, _w, _h)
            // 图片质量
            if (_obj.quality && _obj.quality > 0 && _obj.quality <= 1) {
                _quality = _obj.quality
            }
            let _base64 = _canvas.toDataURL('image/jpeg', _quality)
            _cb && _cb(_base64)
        }
    },
    // 获取base64图片的大小
    fnGetImgByteSize: function(_base64) {
        let _size = null
        if (_base64.graphicContents) { // 获取base64图片byte大小
            const _equalIndex = _base64.graphicContents.indexOf('=') // 获取=号下标
            if (_equalIndex > 0) {
                const _str = _base64.graphicContents.substring(0, _equalIndex) // 去除=号
                const _strLength = _str.length
                const _fileLength = _strLength - (_strLength / 8) * 2 // 真实的图片byte大小
                _size = Math.floor(_fileLength) // 向下取整
            } else {
                const _strLength = _base64.graphicContents.length
                const _fileLength = _strLength - (_strLength / 8) * 2
                _size = Math.floor(_fileLength) // 向下取整
            }
        } else {
            _size = null
        }
    },
    // 将图片base64转为文件流对象
    fnBase64ToFile: function(_base64, _fileName) {
        let _arr = _base64.split(','),
            _mime = _arr[0].match(/:(.*?);/)[1],
            _bstr = atob(_arr[1]),
            _n = _bstr.length,
            _u8arr = new Uint8Array(_n)
        while (_n--) {
            _u8arr[_n] = _bstr.charCodeAt(_n)
        }
        return new File([_u8arr], _fileName || new Date().getTime() + '.jpg', {
            type: _mime
        })
    },
    // 保留两位小数
    fnTwoFloat: function(_num) {
        if (!_num) return _num
        let _arr = String(_num).split('.')
        let _text = _arr[0]
        if (!_arr[1] || _arr[1].length < 2) {
            _text += _arr[1] ? '.' + _arr[1] : '.'
            let _index = _arr[1] ? _arr[1].length : 0
            while (_index < 2) {
                _text += '0'
                    ++_index
            }
        } else {
            _text += '.' + _arr[1].substring(0, 2)
        }
        return _text
    },
    // 获取参建单位页面参数
    fnGetUrlParams: function(_url) {
        _url = _url ? _url : location.href
        let _obj = {}
        if (_url.indexOf('?') != -1 && _url.split('?')[1].indexOf('project') != -1) {
            let _params = location.href.split('?')[1]
            _params = _params.replace(/%2B/g, '+')
            _params = _params.replace(/%2F/g, '/')
            let _arr = _params.split('&')
            _arr.forEach(_item => {
                let _key = _item.split('=')[0]
                let _val = decodeURIComponent(_item.split('=')[1])
                _obj[_key] = _val
            })
        } else {
            return false
        }
        return _obj
    },
    // 塔机/扬尘/升降机--设备运行状态
    fnCraneStatusToText: function(_status, _name) {
        // 塔机运行状态
        // _status = '21000000'
        //设备状态 0bit高度;1bit幅度;2bit回转;3bit载重;4bit力矩;5bit风速;6bit倾角;7bit其它;
        //高度 、载重、力矩、风速、倾角、其它 0:正常,1:预警 2:报警
        //幅度 0:正常 1:近端限位预警 2:近端限位报警；3:远端限位预警 4:远端限位报警
        //回转 0:正常 1:左限位预警 2:左限位报警 3:右限位预警 4:右限位报警
        let _statusCraneInfo = [
            ['高度正常', '高度预警', '高度报警'],
            ['幅度近端限位正常', '幅度近端限位预警', '幅度近端限位报警', '幅度远端限位预警', '幅度远端限位报警'],
            ['回转左限位正常', '回转左限位预警', '回转左限位报警', '回转右限位预警', '回转右限位报警'],
            ['载重正常', '载重预警', '载重报警'],
            ['力矩正常', '力矩预警', '力矩报警'],
            ['风速正常', '风速预警', '风速报警'],
            ['倾角正常', '倾角预警', '倾角报警'],
            ['其它正常', '其它预警', '其它报警'],
        ]
        // 扬尘运行状态
        // _status = '210'
        // 设备状态 0bitpm2.5;1bitpm10;2bit噪声;
        // 0:正常,1:预警 2:报警
        let _statusEnvironmentInfo = [
            ['pm2.5正常', 'pm2.5预警', 'pm2.5报警'],
            ['pm10正常', 'pm10预警', 'pm10报警'],
            ['噪音正常', '噪音预警', '噪音报警'],
        ];
        // 升降机运行状态
        // _status = '21000'
        // 设备状态 0bit重量; 1bit高度;2bit速度;3bit人数;4bit倾斜;5bit身份认证
        // 0:正常,1:预警,2:报警
        let _statusElevatorInfo = [
            ['重量正常', '重量预警', '重量报警'],
            ['高度正常', '高度预警', '高度预警'],
            ['速度正常', '速度预警', '速度报警'],
            ['人数正常', '人数预警', '人数报警'],
            ['倾斜正常', '倾斜预警', '倾斜报警'],
            ['身份认证正常', '身份认证预警', '身份认证报警']
        ];

        let _statusUnloadingInfo = [
            ['重量正常', '重量预警', '重量报警'],
            ['倾角X正常', '倾角X预警', '倾角X报警'],
            ['倾角Y正常', '倾角Y预警', '倾角Y报警'],
        ];

        // _name: crane||environment||elevator
        let _statusInfo
        switch (_name) {
            case 'crane':
                _statusInfo = _statusCraneInfo
                break;
            case 'environment':
                _statusInfo = _statusEnvironmentInfo
                break;
            case 'elevator':
                _statusInfo = _statusElevatorInfo
                break;
            case 'unloading':
                _statusInfo = _statusUnloadingInfo
                break;
            default:
                break;
        }
        let _obj = {
            text: [],
            msg: '正常',
            status: 0,
            textArr: []
        }
        for (let i = 0; i < _status.length; i++) {
            _obj.textArr.push({
                text: _statusInfo[i][_status[i]],
                status: _status[i]
            })
            if (_status[i] != APP.NO) {
                _obj.text.push(_statusInfo[i][_status[i]])
            }
        }
        let _text = JSON.stringify(_obj.text)
        if (_text.indexOf('预警') != -1) {
            _obj.msg = '预警'
            _obj.status = 1
        }
        if (_text.indexOf('报警') != -1) {
            _obj.msg = '报警'
            _obj.status = 2
        }
        if (!_obj.text.length) {
            _obj.text.push('正常')
        }
        _obj.text = _obj.text.join(',')
        return _obj
    },
    // 人员部门、职位格式化
    fnPositionToText: function(_data) {
        if (!_data) {
            return {}
        }
        let _obj = {
            id: _data.split('#')[0],
            text: _data.split('#')[1]
        }
        return _obj
    },
    // 班组格式化 去掉 #
    fnTeamFormat: function(_name) {
        let _text = ''
        if (_name) {
            if (_name.indexOf('#') !== -1) {
                // _text = _name.split('#')[1]
                _text = _name.slice(_name.indexOf('#') + 1)
            } else {
                _text = _name
            }
        }
        return _text
    },
    // 身份证号格式化
    fnCodeFormat(_code) {
        if (_code.length > 8) {
            return _code.substring(0, 4) + '******' + _code.substring(_code.length - 4, _code.length);
        } else {
            return _code;
        }
    },
    // 人员状态
    fnStatusToText(_status) {
        let _text = '';
        switch (_status) {
            case 0:
                _text = '禁用';
                break;
            case 1:
                _text = '启用';
                break;
        }
        return _text;
    },
    // 门禁设备在线状态
    fnOnlineStatusText: function(_heartbeatTime) {
        let _text = _heartbeatTime ? '' : '离线'
        let _status = 0
        let _time = new Date().getTime()
        let _differentTime = 1000 * 60 * 2 // 心跳间隔时间，两分钟
        if (_heartbeatTime) {
            let _different = _time - _heartbeatTime * 1000
            _text = _different >= _differentTime ? '离线' : '在线'
            _status = _different >= _differentTime ? 0 : 1
        }
        let _obj = {
            text: _text,
            status: _status,
            date: new Date(_heartbeatTime * 1000).Format('yyyy-MM-dd hh:mm:ss')
        }
        return _obj
    },
    // AES加密
    /**
     * 接口数据加密函数
     * @param str string 需加密的json字符串
     * @param key_hash string 加密key_hash(16位)
     * @param iv string 加密向量(16位)
     * @return string 加密密文字符串
     */
    fnAesEncrypt: function(str) {
        // let _key = 'cqxtkj'
        // return cryptoJs.AES.encrypt(cryptoJs.enc.Utf8.parse(_text), _key).toString()
        if (!str) {
            return str;
        }
        //密钥
        var key = cryptoJs.enc.Utf8.parse('BdxgU5iO3LPqhf3iDIFemTc5JiCu84Ij');
        //加密向量
        var encrypted = cryptoJs.AES.encrypt(str, key, {
            iv: cryptoJs.enc.Utf8.parse('ZZWBKJ_ZHIHUAWEI'),
            mode: cryptoJs.mode.CBC,
            padding: cryptoJs.pad.ZeroPadding
        });
        return encrypted.toString();
    },
    // AES解密
    /**
     * 接口数据解密函数
     * @param str string 已加密密文
     * @param key_hash string 加密key_hash
     * @param iv string 加密向量
     * @returns {*|string} 解密之后的json字符串
     */
    fnAesDecrypt: function(str) {
        // let _key = 'cqxtkj'
        // return cryptoJs.AES.decrypt(_text, _key).toString(cryptoJs.enc.Utf8)
        if (!str) {
            return str;
        }
        console.log(str)

        str = decodeURIComponent(str)
        console.log(str)
        //密钥
        var key = cryptoJs.enc.Utf8.parse('BdxgU5iO3LPqhf3iDIFemTc5JiCu84Ij');
        //加密向量
        var decrypted = cryptoJs.AES.decrypt(str, key, {
            iv: cryptoJs.enc.Utf8.parse('ZZWBKJ_ZHIHUAWEI'),
            mode: cryptoJs.mode.CBC,
            padding: cryptoJs.pad.Pkcs7
        });
        let _data = decrypted.toString(cryptoJs.enc.Utf8)

        console.log(_data)

        // return decrypted.toString(cryptoJs.enc.Utf8);
        return _data.slice(0, (_data.lastIndexOf('}') + 1))
    },
    // 跳转至 老项目端
    goProject: function() {
        let username = getUserInfo().id
        let password = getUserInfo().project_password
        removeUserInfo()
        removeToken()
        // 判断如果跳转页面没有登录信息时的情况
        if (!username && !password) {
            // 调用方法-> 判断地址栏是否有信息
            let _text = APP.fnGetUrlParams()
            // 如果有信息
            if (_text) {
                let _info = APP.fnAesDecrypt(_text.project)
                Util.fnSetLoginInfo(_info)
            } else {
                let _urls = APP.isTest ? APP.HOST.TEST.ENTER_URL : APP.HOST.OFFICIAL.ENTER_URL;
                window.location = _urls
            }
            return
        }
        let _requestUrl = APP.isTest ? APP.HOST.TEST.TOPROJECT_URL : APP.HOST.OFFICIAL.TOPROJECT_URL;
        axios.post(_requestUrl + '/login', {
                username,
                password
            }).then(res => {
                if (res.data.code == 1) {
                    let _project = String(APP.fnAesEncrypt(JSON.stringify(res.data.data)))

                    _project = _project.replace(/\+/g, '%2B')
                    _project = _project.replace(/\//g, '%2F')
                    let _urls = APP.isTest ? APP.HOST.TEST.TARGET_URL : APP.HOST.OFFICIAL.TARGET_URL;
                    window.location = _urls + '?project=' + _project
                    return
                } else {
                    Message.error(res.data.data)
                }
            })
            .catch(err => {
                Message.error(err);
            })
    },
    // 获取文件名后缀
    fnGetSuffix: function(filename) {
        let pos = filename.lastIndexOf('.')
        let suffix = ''
        if (pos != -1) {
            suffix = filename.substring(pos + 1)
        }
        return suffix
    },
    // 随机生成字符串
    fnGetRandomName: function(len) {
        len = len || 32;
        let chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
        let maxPos = chars.length;
        let pwd = '';
        for (let i = 0; i < len; i++) {
            pwd += chars.charAt(Math.floor(Math.random() * maxPos));
        }
        return pwd;
    },
    // 解密重庆、两江建委身份证号
    fnIdCardDecrypt: function(id_card, sha1_str, _fn) {
        setTimeout(() => {
            console.log(id_card)
            if (id_card.indexOf("*") == -1) {
                return _fn(id_card)
            }
            let arr = id_card.split("****");
            if (arr.length !== 2) {
                return _fn(id_card)
            }
            let pad = function(n) {
                let nn = n
                if (n < 10) {
                    nn = '0' + n;
                }
                return nn.toString()
            }
            let month = function(qy, Y) {
                for (let m = 1; m <= 12; m++) {
                    let mm = pad(m)
                    for (let d = 1; d <= 31; d++) {
                        let dd = pad(d)
                        if (sha1(arr[0] + qy + Y + mm + dd + arr[1]) === sha1_str) {
                            return arr[0] + qy + Y + mm + dd + arr[1]
                        }
                    }
                }
                return null
            }
            for (let q = 0; q <= 99; q++) {
                let qy = pad(q)
                for (let Y = 1970; Y <= 2004; Y++) {
                    let m = month(qy, Y)
                    if (m !== null) {
                        return _fn(m)
                    }
                }
                for (let Y = 1969; Y >= 1950; Y--) {
                    let m = month(qy, Y)
                    if (m !== null) {
                        return _fn(m)
                    }
                }
            }
            _fn(id_card)
        })
    },
    fnRefreshHardHat() {
        let userInfo = getUserInfo()

        let extend = JSON.parse(userInfo.extend)

        console.log(extend);

        if (!extend.hardHatPkey) {
            Message.error("请先联系我司商务进行开通！");
            return;
        }

        axios.post('https://caps.runde.pro/api/index.php?ctl=tool&act=get_token&user_name=' + extend
                .hardHatUserName + '&pkey=' + extend.hardHatPkey).then(
                res => {
                    console.log(res);
                    if (res.data.status) {
                        window.open('https://caps.runde.pro/login#token=' + res.data.session_id +
                            '&user_name=' + extend.hardHatUserName, "_blank");
                    } else {
                        Message.error(res.data.msg)
                    }
                })
            .catch(err => {
                Message.error(err);
            })
    },

    // 搜索人员库
    fnSearchPersonnelDatabase(_idcard, _read, _that, _type) {

        if (_idcard.length != 18) return;

        request({
                url: 'personnel/searchPersonnelDatabase?idcard=' + _idcard + '&read=' + (_read ? 1 : 0),
                method: 'GET'
            })
            .then(res => {

                if (!res.data) return
                _that.$confirm('在基础数据库中找到该人员信息, 是否引用?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    APP.fnChangePersonnel(_that, res.data, _type)
                })
            });
    },
    fnSearchPersonnelDatabaseName(_name, _that) {
        _that.notPersonnelText = '未搜索到该人员数据，请自行录入'
        request({
                url: 'personnel/searchPersonnelDatabaseName?name=' + _name,
                method: 'GET'
            })
            .then(res => {
                _that.searchPersonnelDatabaseName = res.data
                _that.$nextTick(() => {
                    _that.$refs.searchPersonnelRef.toggleMenu()
                });
            })
            .catch(err => {
                _that.$message.error(err.data);
            });
    },
    fnChangePersonnel(_that, _data, _type) {
        for (let _key in _data) {

            if (_key == 'validity_period' && _data[_key]) {
                let _validity_period = _data[_key].split('-');
                if (_validity_period[1] == '长期') {
                    _that.showDate = false;
                    _that.dateStart = APP.fnDateAddEm_public(_validity_period[0]);
                    _that.dateEnd = _validity_period[1];
                } else {
                    _that.showDate = true;
                    _that[_type][_key] = [APP.fnDateAddEm_public(_validity_period[0]),
                        APP.fnDateAddEm_public(_validity_period[1])
                    ];
                }
            } else {
                _that[_type][_key] = _data[_key];
            }
        }
    },


    fnAutoSendPersonState(_d, _eqpt) {
        if (!_d) return;
        let data = JSON.parse(_d);
        let d = [];
        for (let i in _eqpt) {
            _eqpt[i].sn

            if (!data[_eqpt[i].sn]) {
                continue;
            }

            let task = JSON.parse(data[_eqpt[i].sn])

            d.push({
                sn: _eqpt[i].sn,
                name: _eqpt[i].name,
                model: _eqpt[i].model,
                record_type: _eqpt[i].record_type == 0 ? '无效' : (_eqpt[i].record_type == 1 ? '进门' : '出门'),
                lanIP: _eqpt[i].lanIP,
                heartbeatTime: _eqpt[i].heartbeatTime,
                type: task.type,
                status: task.status,
                details: task.details == 'ok' ? 'success' : task.details
            })
        }

        return d;
    },
    fnSendPersonToAllAccess(_data, _eqpt) {
        request({
                url: 'project/getProjectInfo',
                method: 'GET'
            })
            .then(res => {
                if (!res.data.auto_send_person) return;
                for (let i in _eqpt) {
                    APP.fnSendPersonToAccess(null, _data, {
                        sn: _eqpt[i].sn,
                        heartbeatTime: _eqpt[i].heartbeatTime,
                    })
                }
            })
            .catch(err => {
                _that && _that.$message.error(err.data);
            });
    },
    fnSendPersonToAccess(_that, _data, _eqpt) {

        if (!APP.fnOnlineStatusText(_eqpt.heartbeatTime).status) {
            _that && _that.$message.error('该设备已离线，无法重试！');
            return;
        }

        request({
                url: 'task/add',
                method: 'POST',
                data: {
                    name: '下发人员至设备',
                    content: '下发人员至设备,设备SN:' + _eqpt.sn
                }
            })
            .then(res => {
                request({
                        url: (APP.isTest ? APP.HOST.TEST.TASK_DELIVER : APP.HOST.OFFICIAL
                            .TASK_DELIVER) + '/task/deliver/',
                        method: 'POST',
                        data: {
                            eqptSN: _eqpt.sn,
                            cmd: 'sendPerson',
                            data: JSON.stringify([{
                                'personnel_id': _data.id,
                                'name': _data.name,
                            }]),
                            tid: res.data.tid
                        }
                    })
                    .then(res => {
                        _that && _that.$message.success('任务投递成功，请稍后刷新页面查看结果');
                        _eqpt.status = 0
                        _eqpt.details = '正在执行'
                    })
                    .catch(err => {
                        _that && _that.$message.error(err.data);
                    });
            })
            .catch(err => {
                _that && _that.$message.error(err.data);
            });
    }


}
export default APP



// WEBPACK FOOTER //
// ./src/utils/base.js